import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@klickdata/core/auth';
import { MobileService } from '@klickdata/core/mobile';
import { QuestionTypes } from '@klickdata/core/question';
import { Resource, ResourceService, ResourceSocketService } from '@klickdata/core/resource';
import { ResourceItemDirective } from '../resource-item.directive';
import { BehaviorSubject, Observable, takeUntil } from 'rxjs';
import { PromptState } from '@klickdata/core/application/src/model/model-interface';
import { Utils } from '@klickdata/core/util';
import { ResourceItem, ResourceItemService } from '@klickdata/core/resource-item';
import { Media } from '@klickdata/core/media/src/media.model';

@Component({
    selector: 'app-resource-builder-scorm',
    templateUrl: './resource-builder-scorm.component.html',
    styleUrls: ['./resource-builder-scorm.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceBuilderScormComponent extends ResourceItemDirective implements OnDestroy {
    public scormMedia: Media;
    public resourceItems$: Observable<ResourceItem[]>;
    Utils = Utils;
    public scormParserPromptStateSub: BehaviorSubject<PromptState> = new BehaviorSubject<PromptState>(null);
    constructor(
        protected resourceService: ResourceService,
        protected changeRef: ChangeDetectorRef,
        protected dialog: MatDialog,
        protected authService: AuthService,
        protected mobileService: MobileService,
        protected bottomSheet: MatBottomSheet,
        protected resourceSocketService: ResourceSocketService,
        protected resourceItemService: ResourceItemService
    ) {
        super(resourceService, changeRef, dialog, authService, mobileService, bottomSheet);
    }
    afterResourceInit() {
        this.scormParserPromptStateSub.next(
            this.selected?.prompt_states?.find((state) => state.type === 'scorm_parser')
        );
        if (this.selected.id) {
            this.buildResourceSocket();
            this.resourceItems$ = this.resourceItemService.getResourceItems(this.selected.id);
        }
    }
    private buildResourceSocket() {
        this.resourceSocketService
            .listenToResourceUpdates({ res_id: this.selected.id })
            .pipe(takeUntil(this.destroy))
            .subscribe((resource) => {
                this.scormParserPromptStateSub.next(
                    resource?.prompt_states?.find((state) => state.type === 'scorm_parser')
                );
                this.resourceItems$ = this.resourceItemService.getResourceItems(this.selected.id);
            });
    }

    onRetry(prompt: string) {
        this.resourceService
            .update({ id: this.selected.id, scorm_uri: prompt }, true)
            .pipe(takeUntil(this.destroy))
            .subscribe(() => this.scormParserPromptStateSub.next({ type: 'scorm_parser', status: 'PROCESSING' }));
    }

    onScormUploaded(media: Media) {
        const scormUri = media.path + '/' + media.filename;
        this.resourceService
            .update({ id: this.selected.id, scorm_uri: scormUri }, true)
            .pipe(takeUntil(this.destroy))
            .subscribe(() => {
                this.scormMedia = media;
                this.changeRef.markForCheck();
            });
    }
    onRemove() {
        this.resourceService
            .update({ id: this.selected.id, scorm_uri: '' }, true)
            .pipe(takeUntil(this.destroy))
            .subscribe(() => {
                this.scormMedia = null;
                this.scormParserPromptStateSub.next(null);
                this.resourceItems$ = null;
            });
    }
}
